import styled from 'styled-components';
const StyledPaymentListContainer = styled.div``;
export default StyledPaymentListContainer;
